
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/bakerhome-ir.jpg"  />
     
        <p>
            وب سایت خانه بیکری توسط یاسر بابایار کدنویسی اختصاصی گردیده و در حال توسعه می‌باشد
        </p>
        <a
          className="App-link"
          href="https://webmaster7.ir/portfolio"
          target="_blank"
          rel="noopener noreferrer"
        >
          
          
          ©️Copyright 2024. All Rights Reserved - Design By : YaserBabayar.ir
        </a>
      </header>
    </div>
  );
}

export default App;
